import ErrorActivationIcon from "../../../../image/AnaliticsStatuses/ErrorActivation.svg"
import HooliganismIcon from "../../../../image/AnaliticsStatuses/Hooliganism.svg"
import MalfunctionIcon from "../../../../image/AnaliticsStatuses/Malfunction.svg"
import UnknownCauseIcon from "../../../../image/AnaliticsStatuses/UnknownCause.svg"
import UnwantedTriggeringIcon from "../../../../image/AnaliticsStatuses/UnwantedTriggering.svg"

export const ANALITICS_DATA = [
    {
        id: 1,
        title: "Неисправность",
        subtitle: "Техническая неисправность оборудования",
        color: "var(--redAccent)",
        icon: MalfunctionIcon
    },
    {
        id: 2,
        title: "Хулиганство",
        subtitle: "Злонамеренные действия человека",
        color: "var(--orangeAccent)",
        icon: HooliganismIcon
    },
    {
        id: 3,
        title: "Нежелательное срабатывание",
        subtitle: "Воздействие факторов, схожих с пожаром",
        color: "var(--purpleAccent)",
        icon: UnwantedTriggeringIcon 
    },
    {
        id: 4,
        title: "Неизвестная причина",
        subtitle: "Причина не может быть установлена",
        color: "var(--accent)",
        icon: UnknownCauseIcon
    },
    {
        id: 5,
        title: "Ошибочная активация",
        subtitle: "Подача сигнала о пожаре по ошибке",
        color: "var(--headers)",
        icon: ErrorActivationIcon
    },
]